export const FORM = {
  TYPE: {
    INPUT: 'INPUT',
    SELECT: 'SELECT',
  },
};
